<template>
  <v-row align="stretch">
    <v-col cols="12" md="6">
      <profile-card />
    </v-col>
    <v-col cols="12" md="6">
      <payment-card />
    </v-col>
  </v-row>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import ProfileCard from '@/components/Cards/Profile/ProfileCard'
import PaymentCard from '@/components/Cards/Profile/PaymentCard'

export default {
  name: 'ProfileInfo',
  components: {
    ProfileCard,
    PaymentCard,
  },
  data () {
    return {
      showEditProfile: false,
      showAddPayment: false,
      baseUrl: process.env.BASE_URL,
    }
  },
  computed: {
    ...mapGetters(['SessionProfile']),
  },
  methods: {
    ...mapActions(['UpdateProfile']),
  },
}
</script>
